import COUNTRIES from '../countries.translations'

import type { Metal } from './types'
import translations from './vanadium.content'

const t = translations
const dir = '/mine-my-phone/images/metals/vanadium'

export const vanadium: Metal = {
  id: 36,
  slug: 'vanadium',
  name: t.name,
  symbol: 'V',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Panzhihua, vanadium mine (China)',
      region: t.mine0Region,
      slug: 'panzhihua',
      coordinates: [101.72, 26.58],
    },
    {
      name: 'Mokopane, vanadium mine (South Africa)',
      region: t.mine1Region,
      slug: 'mokopane',
      coordinates: [29.01, -24.19],
    },
    {
      name: 'Kachkanar, vanadium mine (Russia)',
      region: t.mine2Region,
      slug: 'kachkanar',
      coordinates: [59.49, 58.7],
    },
    {
      name: 'Steelpoort, vanadium mine (South Africa)',
      region: t.mine3Region,
      slug: 'steelpoort',
      coordinates: [30.2, -24.73],
    },
    {
      name: 'Maracás, vanadium mine (Brazil)',
      region: t.mine4Region,
      slug: 'maracas',
      coordinates: [-40.43, -13.44],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 67.3 },
    { name: COUNTRIES.russia, percent: 19.2 },
    { name: COUNTRIES.southAfrica, percent: 8.3 },
    { name: COUNTRIES.brazil, percent: 5.2 },
  ],
  // The metal it is alloyed into.
  related: ['titanium'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
